import(/* webpackMode: "eager", webpackExports: ["ClubsClientWrapper"] */ "/app/apps/pickleball/src/modules/players/v2/tabs/clubs/ClubsClientWrapper.tsx");
